import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ead79f36"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }

import CourseItem from "@/components/CourseItem.vue";
import axios from "axios";
import { onMounted, ref } from "vue";
import { useUserStore } from "@/store/userStore";
import StudyLanguageToggle from "@/components/StudyLanguageToggle.vue";
import DailyMilestoneBar from "@/components/DailyMilestoneBar.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ExerciseListView',
  setup(__props) {

const store = useUserStore();
const courses = ref([]);
const isLoading = ref(false);

const getCourses = async () => {
  isLoading.value = true;
  try {
    const response = await axios.get("api/course/list");
    courses.value = response.data.filter(
      (course) =>
        course.type === "SUBJECT" &&
        course.courseLanguage === store.selectedStudyLang,
    );
  } catch (error) {
    console.error("Failed to fetch courses", error.message);
  } finally {
    isLoading.value = false;
  }
};

onMounted(() => {
  getCourses();
});

return (_ctx: any,_cache: any) => {
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "my-container" }, {
    default: _withCtx(() => [
      _createVNode(DailyMilestoneBar),
      _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.$t("exerciseListView.chooseExercise")), 1),
      _createVNode(StudyLanguageToggle, { onUpdateLanguage: getCourses }),
      _createVNode(_component_v_row, {
        justify: "center",
        class: "custom-row"
      }, {
        default: _withCtx(() => [
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t("exerciseListView.loading")), 1))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(courses.value, (course) => {
                  return (_openBlock(), _createBlock(CourseItem, {
                    key: course.id,
                    course: course
                  }, null, 8, ["course"]))
                }), 128)),
                (courses.value.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$t("exerciseListView.noCourseToDisplay")), 1))
                  : _createCommentVNode("", true)
              ], 64))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})